import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { services, site } from "../data/site";

const guideSlugs = [
  "marble-polishing-service",
  "granite-polishing-services",
  "quartz-polishing-service",
  "terrazzo-polishing-service",
  "tile-and-grout-cleaning-service",
  "concrete-floor-polishing",
  "parquet-floor-polishing",
  "travertine-polishing-service",
];

export default function BlogPage() {
  const guides = guideSlugs
    .map((slug) => services.find((service) => service.slug === slug))
    .filter(Boolean);

  return (
    <>
      <SEO
        title="Stone Care Guides Singapore | Polishing Singapore"
        description="Read polishing and restoration guides for marble, granite, quartz, terrazzo, tile and grout, concrete, parquet and natural stone surfaces."
        canonical={`${site.domain}/blog`}
      />
      <PageHero title="Stone Care Guides" description="A focused guide index for polishing, restoration, repair, cleaning and maintenance topics." image="/assets/polishing/service_natural_stone.webp" />
      <section className="section-pad bg-background-50">
        <div className="section-shell grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {guides.map((guide) => guide && (
            <article key={guide.slug} className="surface-card overflow-hidden">
              <img src={guide.image} alt={guide.title} className="h-56 w-full object-cover" />
              <div className="p-6">
                <p className="eyebrow">{guide.category}</p>
                <h2 className="mt-3 font-heading text-2xl font-bold">{guide.title}</h2>
                <p className="mt-3 line-clamp-4 text-sm leading-7 text-foreground-700">{guide.excerpt}</p>
                <Link to={`/services/${guide.slug}`} className="mt-5 inline-flex items-center gap-2 text-sm font-bold text-primary-700">
                  Read guide
                  <ArrowRight size={16} />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
